import { pick, upperCase } from 'lodash';
import Cookies from 'js-cookie';
import URI from 'urijs';

const APP_QUERY_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_referrer',
  'utm_term',
  'utm_content',
  'aflt',
];
export const APP_LINKS = {
  IOS: 'https://redirect.appmetrica.yandex.com/serve/25914344223015417',
  ANDROID: 'https://redirect.appmetrica.yandex.com/serve/890605467947054370',
  RUSTORE: 'https://apps.rustore.ru/app/level.travel',
  APPGALLERY: 'https://appgallery.huawei.com/app/C102984487',
};

export const openAppStore = (deviceType, extraParams) => {
  const appStoreUrl = APP_LINKS[upperCase(deviceType)];
  const uri = new URI(appStoreUrl);
  const queryParams = pick(URI.parseQuery(URI().search()), APP_QUERY_PARAMS);
  const cookieParams = {
    utmz: Cookies.get('__utmz'),
    uuid: Cookies.get('ccx-uuid'),
  };
  uri.addQuery({
    ...queryParams,
    ...cookieParams,
    ...(extraParams || {}),
  });

  const ltref = Cookies.get('lt_ref');
  if (ltref) {
    const [, , refParams] = ltref.split('|');
    const aflt = window.PARTNER && window.PARTNER.name;
    uri.setQuery('aflt', aflt);
    try {
      refParams.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        uri.addQuery({ [key]: value });
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('failed to parse lt_ref:', ltref);
    }
  }
  window.open(uri.toString(), '_self');
};

export const getAppStoreLink = (deviceType, extraParams) => {
  const appStoreUrl = APP_LINKS[upperCase(deviceType)];
  const uri = new URI(appStoreUrl);
  const queryParams = pick(URI.parseQuery(URI().search()), APP_QUERY_PARAMS);
  const cookieParams = {
    utmz: Cookies.get('__utmz'),
    uuid: Cookies.get('ccx-uuid'),
  };
  uri.addQuery({
    ...queryParams,
    ...cookieParams,
    ...(extraParams || {}),
  });

  const ltref = Cookies.get('lt_ref');
  if (ltref) {
    const [, , refParams] = ltref.split('|');
    const aflt = window.PARTNER && window.PARTNER.name;
    uri.setQuery('aflt', aflt);
    try {
      refParams.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        uri.addQuery({ [key]: value });
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('failed to parse lt_ref:', ltref);
    }
  }
  return uri.toString();
};

export const setMobileCookie = (isMobile) => {
  const value = isMobile ? 'no' : 'yes';
  const domain = window.ENV_DOMAIN ? `.${window.ENV_DOMAIN}` : 'all';

  Cookies.set('mobile', value, {
    domain,
    path: '/',
  });
};
